import { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { Button } from 'antd';
import { snappy } from 'src/_shared';
import RecognitionRewardsPresentation from '../../presentation/recognitionRewards/RecognitionRewardsPresentation';

const RecognitionRewardsContainer = () => {
  const [recognitions, setRecognitions] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const currentUser = useSelector((state) => state.user.currentUser);

  useEffect(() => {
    getRecognitions();
  }, []);

  const getRecognitions = async () => {
    setIsLoading(true);
    try {
      const response = await snappy({
        type: 'getRecognitions',
        userId: currentUser.id,
      });
      
      setRecognitions(response || []);
    } catch (error) {
      console.error('Error fetching recognitions:', error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleRecognitionStateChange = async (newState, recognitionId) => {
    try {
      await snappy({
        type: 'updateRecognitionStatus',
        userId: currentUser.id,
        recognitionId,
        status: newState,
      });
      
      // Update local state
      setRecognitions(prevRecognitions => 
        prevRecognitions.map(recognition => 
          recognition.id === recognitionId 
            ? { ...recognition, status: newState } 
            : recognition
        )
      );
    } catch (error) {
      console.error('Error updating recognition status:', error);
    }
  };

  const addTestRecognition = () => {
    // Create a mock recognition with unviewed status
    const testRecognition = {
      id: `test-${Date.now()}`,
      title: 'Test Recognition',
      description: 'This is a test recognition to verify animations',
      status: 'unviewed',
      createdAt: new Date().toISOString(),
      giftDetails: {
        link: 'https://example.com/gift'
      }
    };
    
    // Add the test recognition to the beginning of the array
    setRecognitions(prevRecognitions => [testRecognition, ...prevRecognitions]);
  };

  return (
    <div>
      <Button
        type="primary"
        onClick={addTestRecognition}
        style={{ marginBottom: '10px' }}
      >
        Add Test Recognition
      </Button>
      <RecognitionRewardsPresentation
        recognitions={recognitions}
        currentUser={currentUser}
        isLoading={isLoading}
        onStateChange={handleRecognitionStateChange}
      />
    </div>
  );
};

export default RecognitionRewardsContainer;